<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5"></a>
<h1 class="toc-title"><span class="bold">CONTENTS</span></h1>
<h2 class="tocf"><a href="#/xhtml/04_Dedication">Dedication</a></h2>
<h2 class="tocf"><a href="#/xhtml/05_Acknowledgements">Acknowledgements</a></h2>
<h2 class="tocf"><a href="#/xhtml/06_AuthorsNote">Authors’ Note</a></h2>
<h2 class="tocf"><a href="#/xhtml/07_Introduction">Introduction</a></h2>
<h2 class="toc-ch"><span href="#/xhtml/08_Chapter01" title="Link target outside of Sample">Chapter 1<span class="space">Services after the Grouping based on 1924 Service Timetable</span></span></h2>
<h2 class="toc-ch"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample">Chapter 2<span class="space">Location Analysis</span></span></h2>
<h2 class="toc-h3"><span href="#/xhtml/09_Chapter02#ch2-1" title="Link target outside of Sample">Bargoed</span></h2>
<h2 class="toc-h3"><span href="#/xhtml/09_Chapter02#ch2-2" title="Link target outside of Sample">Groesfaen</span></h2>
<h2 class="toc-h3"><span href="#/xhtml/09_Chapter02#ch2-3" title="Link target outside of Sample">Darran &amp; Deri</span></h2>
<h2 class="toc-h3"><span href="#/xhtml/09_Chapter02#ch2-4" title="Link target outside of Sample">Ogilvie Village Halt/Ogilvie Colliery</span></h2>
<h2 class="toc-h3"><span href="#/xhtml/09_Chapter02#ch2-5" title="Link target outside of Sample">Fochriw</span></h2>
<h2 class="toc-h3"><span href="#/xhtml/09_Chapter02#ch2-6" title="Link target outside of Sample">Pantywaun Halt</span></h2>
<h2 class="toc-h3"><span href="#/xhtml/09_Chapter02#ch2-7" title="Link target outside of Sample">Dowlais Top</span></h2>
<h2 class="toc-h3"><span href="#/xhtml/09_Chapter02#ch2-8" title="Link target outside of Sample">Pant</span></h2>
<h2 class="toc-h3"><span href="#/xhtml/09_Chapter02#ch2-9" title="Link target outside of Sample">Pontsticill Junction</span></h2>
<h2 class="toc-ch"><span href="#/xhtml/10_Chapter03" title="Link target outside of Sample">Chapter 3<span class="space">Pant to Dowlais Central</span></span></h2>
<h2 class="toc-h3"><span href="#/xhtml/10_Chapter03#ch3-1" title="Link target outside of Sample">Pant</span></h2>
<h2 class="toc-h3"><span href="#/xhtml/10_Chapter03#ch3-2" title="Link target outside of Sample">Pantyscallog</span></h2>
<h2 class="toc-h3"><span href="#/xhtml/10_Chapter03#ch3-3" title="Link target outside of Sample">Dowlais (Lloyd Street)/Dowlais Central</span></h2>
<h2 class="toc-h3"><span href="#/xhtml/10_Chapter03#ch3-4" title="Link target outside of Sample">Passenger &amp; Freight Working</span></h2>
<h2 class="toc-h3"><span href="#/xhtml/10_Chapter03#ch3-5" title="Link target outside of Sample">Dowlais Iron Works</span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?a9e0367a